export const slidesLogsSelector = (state) => state.logs.slidesLogs;
